import {ElMessageBox} from 'element-plus'
import { toRaw,reactive } from 'vue'

export async function APIRequest(awaitRequest) {
	try {
		const response = await awaitRequest   
		return  response.data?.content || {status: response.status}
	} catch (error) {
    /*
		ElMessageBox.alert('Помилка комунікації з сервером', {
			confirmButtonText: 'Гаразд',
			type: 'error',
			dangerouslyUseHTMLString: true
		})
    */  
		console.log(error.response)
		return null
	}
}

//функція копіює вміст полів props з обєкта source в обєкт target
export function fillObject(source, target, props) {
  //console.log("target",target) 
  if(!props)  target = structuredClone(deepToRaw(source))
  else {  
    props.forEach(key => {	
      if (!source || source[key] === undefined || source[key] === null) target[key] = ''
      else target[key] = source[key]
    })	
  }
	return target //reactive(target)
}

//функція створює новий масив відфільтрованих через filter() елементів масиву source 
//з окремими полями, зазначеними в props, з обробкою елементів через fun() 
// та сортуванням по полю sortName - закоментовано !!
export function fillNewObjectArray(source,props,fun,filter,sortName) {
	let target = []
	let accept = true
	let index = 0
	source.forEach((el,i) => {	
		if(filter && typeof fun == "function") accept = filter(el,index) 				
		if(accept){		
			target.push(fillObject(el,{},props))
			if(fun && typeof fun == "function") fun(target[index],index) 
			index++	
		}
	})
	//if(!sortName || sortName.length==0) sortName='name'
	//target.sort((a, b) => a[sortName].localeCompare(b[sortName]))
 	return target
}

//функція створює масив обєктів з полями props масиву source, сортує його  
// Заповнює ним мапу map і повертає створений масив
export function fillNewObjectMap(map,source,props,fun,sortName) {
	let target = fillNewObjectArray(source,props,fun,sortName)
  map.clear()
	target.forEach(el => map.set(el.id, el))
	return target
}


//отримати масив біт-індексів
export function flagsToBitIndexes(flagsNum,inString) {
	let flagsArray=[]
	;[...flagsNum.toString(2)].reverse().forEach((v, i) => {
		if (v === '1') flagsArray.push(inString? String(i):i)
	})
	return flagsArray
}

//отримати масив бітів
export function parseFlags(flagsNum,inString) {
	let flagsArray=[]
	;[...flagsNum.toString(2)].reverse().forEach((v, i) => {
		if (v === '1') flagsArray.push(inString? String(2 ** i):2 ** i)
	})
	return flagsArray
}

//отримати маску з масиву бітів
export function arrayToFlags(flagArray){
  return flagArray.reduce((mask, value) => mask + Number(value),0)
}
//отримати біт за індексом
export function getFlagValue(flagsNum,index){
	return (flagsNum & (2 ** index)) != 0
} 
//призначити біт за індексом 
export function setFlagValue(flagsNum, index, value) {
  if (value) return flagsNum | (1 << index) 
  return flagsNum & ~(1 << index)  
}


// функція порівнює властивості двох об'єктів, включаючи масиви та об'єкти
// повертає перелік назв властивостей першого рівня, значення яких різняться
export function compareObjects(obj1, obj2) {
	if (!obj1 || !obj2) return []
	const diffKeys = []
	for (const key in obj1) {
		const val1 = obj1[key]
		const val2 = obj2[key]		
		if (typeof val1 === 'object' && val1 !== null) {	
			if (JSON.stringify(val1) !== JSON.stringify(val2)) diffKeys.push(key)
			continue
		}
		if (val1 !== val2) diffKeys.push(key)
	}
	return diffKeys
}

//функція порівнює о'бєкти однакової структури (новий і старий)
//і повертає об'єкт із зміненими властивостями першого рівня  
export function diffObject(newObj, oldObj) {
  const diff = {}
  const rawNew = toRaw(newObj) || {}
  const rawOld = toRaw(oldObj) || {}
  for (const key of Object.keys(rawNew)) {
    const n = toRaw(rawNew[key])
    const o = toRaw(rawOld[key])
    if (Array.isArray(n) && Array.isArray(o)) {
      if (JSON.stringify(n) !== JSON.stringify(o)) diff[key] = n.map(item => toRaw(item))
    } else if (n && typeof n === 'object' && o && typeof o === 'object') {
      if (JSON.stringify(n) !== JSON.stringify(o)) diff[key] = { ...toRaw(n) }
    } else {
      if (n !== o) diff[key] = n
    }
  }
  return diff
}

//функція порівнює о'бєкти однакової структури (новий і старий) на всю глибину
//і повертає об'єкт із зміненими властивостями на кожному рівні  
export function deepDiffObject(obj1, obj2) {
  const result = {}

  function isObject(value) {
    return value && typeof value === 'object' && !Array.isArray(value)
  }

  function arraysEqual(a, b) {
    if (a.length !== b.length) return false
    return a.every((el, i) => {
      if (isObject(el) && isObject(b[i])) {
        return Object.keys(deepDiffObject(el, b[i])).length === 0
      }
      return el === b[i]
    })
  }

  for (const key of new Set([...Object.keys(obj1), ...Object.keys(obj2)])) {
    const val1 = obj1[key]
    const val2 = obj2[key]

    if (isObject(val1) && isObject(val2)) {
      const nestedDiff = deepDiffObject(val1, val2)
      if (Object.keys(nestedDiff).length > 0) {
        result[key] = nestedDiff
      }
    } else if (Array.isArray(val1) && Array.isArray(val2)) {
      if (!arraysEqual(val1, val2)) {
        result[key] = val1
      }
    } else if (val1 !== val2) {
      result[key] = val1
    }
  }

  return result
}



export function hasUniqueProp(arr,prop) {
  const set = new Set(arr.map(obj => obj[prop].join(',')))
  return set.size === arr.length
}


export function compareTimes(t1, t2) {
    function toMinutes(timeStr) {
        const [hours, minutes] = timeStr.split(":").map(Number)
        return hours * 60 + minutes
    } 
    const m1 = toMinutes(t1)
    const m2 = toMinutes(t2)  
    if (m1 < m2) return -1   
    if (m1 > m2) return 1    
    return 0                 
}


export function deepTrim(value) {
  if (typeof value === 'string') return value.trim()
  if (Array.isArray(value)) {
    for (let i = 0; i < value.length; i++) {
      value[i] = deepTrim(value[i])
    }
    return value
  }
  if (value && typeof value === 'object') {
    for (const key of Object.keys(value)) {
      value[key] = deepTrim(value[key])
    }
    return value
  }
  return value
}

//створення нової мапи з масиву array по ключу key / id 
export function toMap(array,key){
	if(!Array.isArray(array)) return null
	let map=new Map()
	if(!key) key="id"
	array.forEach((el)=>map.set(el[key],el))
	return map
}
//заповнення мапи map з масиву array по ключу key / id
//якщо мапа не передається, вона створюється
export function arrayToMap(array,map,key){
	if(!Array.isArray(array)) return
	if(!key) key="id"
  if(!map) map = new Map()
	else map.clear()
	array.forEach((el)=>map.set(el[key],el))
  return map
}



//функція повертає значення властивості об'єкта obj, яка
//розташована на шляху path будь-якої глибини наприклад  path = "b.items[0].name"  
//якщо path - функція, вона викликається з аргументом obj  
export function getValueByPath(obj, path) {	
  if(typeof path == 'function') return path(obj)
  const keys = path.replace(/\[(\d+)\]/g, '.$1').split('.')
  return keys.reduce((acc, key) => {
    return acc !== undefined && acc !== null ? acc[key] : undefined
  }, obj)
}

//функція повертає ширину рядка  str
export function getStringWidth(str) {
	if (!str || typeof str != "string") return undefined
	const span = document.createElement('span')
	span.style.visibility = 'hidden'
	span.style.position = 'absolute'
	span.style.whiteSpace = 'nowrap'
	span.innerText = str
	document.body.appendChild(span)
	const width = span.getBoundingClientRect().width
	document.body.removeChild(span)	
	return width
}

//функція знімає реактивність на всю глибину
export function deepToRaw(obj) {
  if (Array.isArray(obj)) {
    return obj.map(item => deepToRaw(toRaw(item)))
  } else if (obj !== null && typeof obj === 'object') {
    const raw = toRaw(obj)
    return Object.fromEntries(
      Object.entries(raw).map(([key, value]) => [key, deepToRaw(value)])
    )
  }
  return obj
}
//функція  робить клон реактивного об'єкта і знимає реактивність 
export function deepCloneReactive(obj) {
  return structuredClone(deepToRaw(obj))
}
//функція очищає та заповнює reactive об'єкт copy даними об'єкта orig   
export function fillReactiveCopy(copy,orig){
	Object.keys(copy).forEach(key => {delete copy[key]})
	Object.assign(copy, structuredClone(deepToRaw(orig)))
}


//функція визначає, чи є вузол childId нащадком вузла ancestorId в дереві nodes
export function isDescendantOf(nodes, childId, ancestorId) {
  const map = new Map(nodes.map(n => [n.id, n]))
  const visited = new Set()
  let current = map.get(childId)
  while (current && current.parent_id != null) {
    if (current.parent_id === ancestorId) return true    
    if (visited.has(current.parent_id)) return false
    visited.add(current.parent_id)
    current = map.get(current.parent_id)
  }
  return false
}

//функція повертає всіх нащадків вузла rootId дерева nodes  
export function getSubtree(nodes, rootId) {
  const map = new Map(nodes.map(n => [n.id, n]))
  const result = []
  const visited = new Set()
  function dfs(id) {
    if (visited.has(id)) return 
    visited.add(id)
    const node = map.get(id)
    if (!node) return
    result.push(node)
    for (const child of nodes) {
      if (child.parent_id === id) {
        dfs(child.id)
      }
    }
  }
  dfs(rootId)
  return result
}

export function showMessage(message,type){
    ElMessageBox.alert(message, {
    confirmButtonText: 'Зрозуміло',
    type: type,    
    //appendTo: document.querySelector('.ddTree'),
    dangerouslyUseHTMLString: true
  }).catch(() => {})
}
export function alertMessage(message){
    showMessage(message,"error")
}

export function infoMessage(message){
    showMessage(message,"info")
}

//Функція повертає true, коли користувач натисне "Так"
export async function confirmMessage(message){
  return await ElMessageBox.confirm(message, {
    confirmButtonText: 'Так',
    cancelButtonText: 'Ні',
    type:'info',
    appendTo: document.querySelector('.ddTree'),
    dangerouslyUseHTMLString: true
  }).then(()=>{return true}).catch(()=>{return false})
}



//функція розділяє об'єкт obj по ключам keys, і повертає 
// об'єкт з властивостями keys та "rest", яка містить всі інші властивості. 
export function splitObjectByKeys(obj, keys) {
  const picked = {}
  keys.forEach(k => {if (k in obj) {picked[k] = obj[k]}})
  const rest = Object.fromEntries(
    Object.entries(obj).filter(([key]) => !keys.includes(key))
  )
  return { ...picked, rest }
}

/*
export function __(vars) {
   Object.entries(vars).forEach(([key, value]) => {
    let val = value
    if (value && typeof value === 'object' && 'value' in value)val = value.value
    if (val instanceof Map) val = Object.fromEntries(val)
    if (val instanceof Set) val = Array.from(val)
    console.log(`${key}:`, val)
  })
}
*/
export function __(vars) {
    console.log("log ===========")
	if(typeof vars == 'string' || vars == 'number') {
		console.log(vars)
		return
	}	
	Object.entries(vars).forEach(([key, value]) => {
		let val = value
		if (value && typeof value === 'object' && 'value' in value)val = value.value
		if (val instanceof Map) val = Object.fromEntries(val)
		if (val instanceof Set) val = Array.from(val)	
				
	console.log(`${key}:`, val)
	})
}

